import { DefaultTheme } from 'styled-components/macro';
import modularScale from './helpers/modularScale';

const Theme: DefaultTheme = {
  colors: {
    accentPrimary: '#0061ab',
    accentPrimaryDrk: '#0261ab',
    accentLink: '#4a90e2',
    accentPrimaryLt: '#e3f1fc',
    accentSecondary: '#f2f2f2',
    white: '#fff',
    gray: '#505050',
    ltGray: '#eeeded',
    ltGray2: '#e5e5e5',
    ltGray3: '#f4f4f4',
    ltGray4: '#f9f9f9',
    mdGray: '#d5d5d5',
    mdGray2: '#c1c4cc',
    mdGray3: '#d6dce3',
    grayBorder: '#979797',
    black: '#000',
    ltBlack: '#3f3f3f',
    ltBlack2: '#4a4a4a',
    ltBlack3: '#71767d',
    ltBlack4: '#626262',
    successBg: '#d4eeda',
    successText: '#155723',
    failBg: '#f8d6db',
    failText: '#721c25',
    alertBg: '#cc3333',
    timeoutBg: '#f6a624',
    scrimBg: 'rgba(0, 0, 0, 0.8)',
  },
  boxShadow: {
    button:
      '0 1px 10px 0 rgba(211, 211, 211, 0.5), 0 1px 2px 0 rgba(153, 153, 153, 0.5);',
    card:
      '0 1px 10px 0 rgba(211, 211, 211, 0.5), 0 1px 2px 0 rgba(153, 153, 153, 0.5);',
  },
  border: {
    thin: '1px',
    med: '2px',
  },
  transitions: {
    color: 'color .2s ease',
    bg: 'background-color .2s ease',
  },
  animations: {
    fadeIn: {
      duration: '0.15s',
      iterationCount: 'both',
    },
  },
  height: {
    searchResults: '50vh',
  },
  size: {
    artistImage: '120px',
    artistImageColumn: '150px',
    mdHoverImageWidth: '30vw',
    mdHoverImageHeight: '75vh',
    lgHoverImageWidth: '30%',
    lgHoverImageHeight: '80vh',
  },
  zIndex: {
    default: 0,
    level1: 10,
    level2: 20,
    level3: 30,
  },
  // Responsive
  breakpoints: {
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  space: [
    '0',
    '0.25rem',
    '0.5rem',
    '0.75rem',
    '1rem',
    '1.5rem',
    '2.5rem',
    '3.5rem',
    '5rem',
    '8rem',
    '10rem',
  ],
  spacing: {
    xxsmall: modularScale(-8),
    xsmall: modularScale(-4),
    small: modularScale(-3),
    medium: modularScale(0),
    large: modularScale(2),
    xlarge: modularScale(4),
    xxlarge: modularScale(6),
    huge: modularScale(8),
    enormous: modularScale(10),
  },
  customSpacing: {
    artistResultPadding: '24px',
    tooltipStemHalfWidth: '8px',
  },
};

export default Theme;
